import React from 'react';
import styled from 'styled-components';
import ClockIcon from '../../../../../assets/icons/resources/computer/clock.svg';

const OpeningHoursContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #4f6168;
  margin-top: -10px;

  img {
    margin-left: 2px;
  }
`;

interface OpeningHoursProps {
  hourStart: string;
  hourEnd: string;
}

const OpeningHours = (props: OpeningHoursProps) => {
  const { hourStart, hourEnd } = props;
  return (
    <OpeningHoursContainer>
      <img src={ClockIcon} alt="ClockIcon" />
      <div>
        El horario de atención es de {hourStart} a {hourEnd}.{' '}
      </div>
    </OpeningHoursContainer>
  );
};

export default OpeningHours;
